import { __awaiter, __generator } from "tslib";
import { useState, useEffect, useMemo } from 'react';
import { callServerToGetUrls, processItems, converItemsToProGalleryItems, } from './itemsProcessor';
var itemContainsMedia = function (item) { return !!item.mediaUrl || (item.metaData && !!item.metaData.html); }; // filter out items that dont have a mediaUrl/ html for text
export var useItems = function (items, itemsSrc, BATCH_SIZE, getMoreItemsFromSource) {
    if (BATCH_SIZE === void 0) { BATCH_SIZE = 50; }
    var allProGalleryItems = useMemo(function () {
        return converItemsToProGalleryItems(items, itemsSrc);
    }, [items, itemsSrc]);
    var _a = useState(processItems(allProGalleryItems.slice(0, BATCH_SIZE)).items), itemsToRender = _a[0], setItemsToRender = _a[1];
    useEffect(function () {
        prepareAndSetItems(allProGalleryItems.slice(0, BATCH_SIZE));
    }, [allProGalleryItems]);
    var prepareAndSetItems = function (newItems, currentItems) {
        if (currentItems === void 0) { currentItems = []; }
        var _a = processItems(newItems), itemsToSet = _a.items, shouldGetVideoUrls = _a.shouldGetVideoUrls;
        filterAndThenSetItemsToRender(currentItems.concat(itemsToSet));
        if (shouldGetVideoUrls) {
            callServerToGetUrls({ newItems: itemsToSet, currentItems: currentItems }).then(filterAndThenSetItemsToRender);
        }
    };
    var getMoreItemsFromItemPool = function (from) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getItemsFromPool(from, BATCH_SIZE)];
        });
    }); };
    var getItemsFromPool = function (from, batchSize) {
        if (batchSize === void 0) { batchSize = BATCH_SIZE; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, allProGalleryItems.slice(from, from + batchSize)];
            });
        });
    };
    var getMoreItemsFromItemsSource = function (from) {
        var getMoreItemsFunc = getMoreItemsFromSource || getMoreItemsFromItemPool;
        return getMoreItemsFunc(from).then(function (_items) {
            addItems(_items, from);
        });
    };
    var addItems = function (addedItems, from) {
        var curItems = itemsToRender;
        prepareAndSetItems(addedItems, curItems.slice(0, from));
    };
    var filterAndThenSetItemsToRender = function (itemsToSet) {
        var _items = itemsToSet.filter(itemContainsMedia);
        setItemsToRender(_items || itemsToRender);
    };
    var handleGetMoreItemsRequest = function (from) {
        getMoreItemsFromItemsSource(from);
    };
    return {
        itemsToRender: itemsToRender,
        handleGetMoreItemsRequest: handleGetMoreItemsRequest
    };
};
//# sourceMappingURL=itemsHelper.js.map